import SvgIcon from "./SvgIcon";
import IconButton from "./IconButton";

interface Props {
    className?: string;
    width?: string;
    height?: string;
    sizeInPixel?: number;
}

export default function SymbolPropaneIcon({className = '', width = '', height = '', sizeInPixel}: Props) {
    if (sizeInPixel) {
        width = sizeInPixel + 'px';
        height = sizeInPixel + 'px';
    }
    return <>
        <SvgIcon
            defaultFill={'fill-amber-500'}
            className={className}
            width={width}
            height={height}>
            <path d="M280-320h400q66 0 113-47t47-113q0-66-47-113t-113-47H280q-66 0-113 47t-47 113q0 66 47 113t113 47Zm200-160Zm-80-240h160v-40H400v40ZM280-120v-120q-100 0-170-70T40-480q0-100 70-170t170-70h40v-40q0-33 23.5-56.5T400-840h160q33 0 56.5 23.5T640-760v40h40q100 0 170 70t70 170q0 100-70 170t-170 70v120h-80v-120H360v120h-80Z"/>
        </SvgIcon>
    </>;
}

interface ButtonProps {
    className?: string;
    onClick?: () => void;
    title: string;
    svgClassName?: string;
}

export function SymbolPropaneButton({className = '', onClick, title, svgClassName}: ButtonProps) {
    return <>
        <IconButton
            className={className}
            onClick={onClick}
            title={title}
        >
            <SymbolPropaneIcon className={svgClassName}/>
        </IconButton>
    </>;
}